<div class="flex items-start gap-2">
  <div class="flex min-h-[2.75rem] w-16 shrink-0 items-center justify-center rounded border border-gray-200 bg-gray-50 text-sm text-gray-700" aria-hidden="true">+244</div>
  <div class="min-w-0 grow">
    <ng-content></ng-content>
  </div>
</div>
